export default {"src":"/_next/static/media/x-circle.8aba3fcd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};